import { Box, Button, Text, CircularProgress } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { searchAutocompleteList, searchReset, setHeaderAdvancedSearchParams } from "../../redux/actions/actions";
import { loadAnnouncements } from "../../redux/api_calls/apiCalls";
import IndividualAnnouncementCard from "./IndividualAnnouncementCard";


export default function Announcements({ dashboard }) {
    const { announcementsData, isLoading } = useSelector(state => state.announcementsState)
    const [visibleData, setVisibleData] = useState([])
    const [loadMoreVisible, setLoadMoreVisible] = useState(false);
    const finalSearch = useSelector(state => state.searchState.finalSearch)
    const advancedSearch = useSelector(state => state.advancedSearchState)
    const dispatch = useDispatch()

    const loadMoreHandler = () => {
        setVisibleData(announcementsData.slice(0, visibleData.length + 10))
        setLoadMoreVisible(visibleData.length + 10 < announcementsData.length)
    }

    useEffect(() => {
        if (announcementsData.length) {
            if (dashboard) {
                setVisibleData(announcementsData.slice(0, 3))
            }
            else {
                dispatch(searchAutocompleteList(announcementsData.map(announcement => announcement.title)))
                setVisibleData(announcementsData.slice(0, 10))
                setLoadMoreVisible(announcementsData.length > 10)
            }
        }
        // eslint-disable-next-line
    }, [dashboard, announcementsData])


    useEffect(() => {
        if (!dashboard) {
            if (advancedSearch.length) {
                let filteredResult = []
                advancedSearch.forEach(param => {
                    if (param[1].length > 0) {
                        if (param[0] === "Keywords") {
                            let searchKeywords = param[1].split(',')
                            searchKeywords = searchKeywords.map(word => word.toLowerCase())
                            announcementsData.forEach(announcement => {
                                let announcementKeywords = announcement.keywords.split(',')
                                for (let keyword of announcementKeywords) {
                                    if (searchKeywords.includes(keyword.toLowerCase())) {
                                        filteredResult.push(announcement)
                                        break;
                                    }
                                }
                            })
                        }
                        else {
                            if (filteredResult.length) {
                                filteredResult = filteredResult.filter(announcement => announcement.department.toString().toLowerCase() === param[1].toString().toLowerCase())
                            }
                            else {
                                filteredResult = announcementsData.filter(announcement => announcement.department.toString().toLowerCase() === param[1].toString().toLowerCase())
                            }
                        }
                    }
                })
                if (filteredResult.length) {
                    setVisibleData(filteredResult)
                }
            }
        }
        // eslint-disable-next-line
    }, [advancedSearch])

    useEffect(() => {
        if (!dashboard && finalSearch && finalSearch.length) {
            setVisibleData(announcementsData.filter(announcement => finalSearch.includes(announcement.title)))
        }
        // eslint-disable-next-line
    }, [finalSearch])

    useEffect(() => {
        if (!announcementsData.length) {
            dispatch(loadAnnouncements())
        }
        if (!dashboard) {
            dispatch(setHeaderAdvancedSearchParams(["Keywords", "Department"]))
        }
        return () => dispatch(searchReset())
        // eslint-disable-next-line
    }, [])

    return (
        <Box
            w={dashboard ? '100%' : ['95%', '95%', '95%', '80%']}
            d='flex'
            flexDir='column'
            flex='1'
            justifyContent={!dashboard && 'space-between'}
            alignItems={!dashboard && 'center'}
        >
            {
                dashboard &&
                <Text
                    fontSize='15px'
                    color='#222222'
                    fontWeight='800'
                    style={{ fontFamily: 'Mulish, sans-serif' }}

                >
                    ANNOUNCEMENTS
                </Text>
            }

            <Box
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                w='100%'
                bg='#ffffff'
                d='flex'
                flexDir='column'
                px={dashboard ? '1rem' : '1.5rem'}
                mt='1rem'
                flex='1'
            >
                {
                    isLoading ?
                        <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                            <CircularProgress isIndeterminate color='#3e59de' size='50px' mt='2' />
                        </Box> :
                        !isLoading && visibleData.length > 0 ?
                            visibleData.map((announcement, idx) => <IndividualAnnouncementCard
                                key={idx}
                                dashboard={dashboard}
                                image={announcement.image_url}
                                description={announcement.description}
                                title={announcement.title}
                                startingDate={announcement.start_date}
                                startingTime={announcement.start_time}
                                department={announcement.department}
                            />)
                            :
                            <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='2rem'>
                                <Text
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                    fontWeight="400"
                                    fontSize={["12px", "14px", "16px", "18px"]}
                                >
                                    Nothing to display!
                                </Text>
                            </Box>
                }

            </Box>
            {
                !dashboard &&
                <Box width="100%" d="flex" justifyContent="center" alignItems="center">
                    {loadMoreVisible && (
                        <Button
                            color="#00000099"
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="700"
                            fontSize={["12px", "14px", "16px", "18px"]}
                            border="2px solid rgba(0, 0, 0, 0.1)"
                            boxShadow="0px 3px 16px rgba(0, 0, 0, 0.1)"
                            borderRadius="xl"
                            py={["0.5rem", "0.75rem", "1rem", "1.5rem"]}
                            px={["0.75rem", "1rem", "1.5rem", "2rem"]}
                            m="2rem"
                            bg="#ffffff"
                            onClick={loadMoreHandler}
                        >
                            Load More...
                        </Button>
                    )}
                </Box>
            }
        </Box>

    )
}